import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { Reveal } from "./Reveal";
import { TESTIMONIALS } from "@/data/content";

const EASE = [0.76, 0, 0.24, 1];

export const Testimonials = () => {
  return (
    <section
      id="depoimentos"
      data-testid="testimonials-section"
      className="border-y border-white/10 bg-[#0d0d0d] py-20 sm:py-28"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <Reveal>
            <span className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#FF4444]">
              / 06 — Depoimentos
            </span>
            <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none tracking-tight text-white sm:text-6xl">
              O que dizem<br />nossos clientes
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="flex items-center gap-3">
              <div className="flex gap-1 text-[#D50000]">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={20} fill="currentColor" />
                ))}
              </div>
              <span className="font-mono-t text-sm text-zinc-400">
                Avaliações Google
              </span>
            </div>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <motion.blockquote
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: EASE }}
              className="relative border-l-2 border-[#D50000] bg-[#111111] p-8"
            >
              <Quote size={30} className="text-white/10" fill="currentColor" />
              <div className="mt-3 flex gap-0.5 text-[#D50000]">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={15} fill="currentColor" />
                ))}
              </div>
              <p className="mt-4 font-display text-2xl font-medium uppercase leading-tight tracking-tight text-white">
                “{t.text}”
              </p>
              <cite className="mt-4 block font-mono-t text-xs not-italic uppercase tracking-widest text-zinc-500">
                — {t.author}
              </cite>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
